import { makeStyles } from '../../../styles';
export const useWizardStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        borderRadius: 8,
        width: '100%',
        border: (props) => {
            const { variant } = props;
            return variant === 'outline' ? `1px solid ${theme.colors.gray[200]}` : 'none';
        },
        background: (props) => {
            const { variant } = props;
            return variant === 'contained' ? `${theme.colors.primary.contrastWhite}` : 'transparent';
        },
    },
    leftContent: {
        boxSizing: 'content-box',
        minWidth: 300,
        padding: '30px 10px 10px 20px',
    },
    rightContent: {
        padding: theme.spacing(5),
        display: 'flex',
        overflow: 'hidden',
        flexDirection: 'column',
        borderLeft: () => `1px solid ${theme.colors.gray[200]}`,
        width: '100%',
    },
    mainContent: {
        flexGrow: 1,
        marginBottom: theme.spacing(6.25),
    },
}));
//# sourceMappingURL=Wizard.styles.js.map